const getLocationByAirportCode = (airportsList, airportCode) => {
  if (!airportsList && !airportCode) {
    return null;
  }

  const airportDetails = airportsList[airportCode];
  return `${airportDetails.placeName}, ${airportDetails.countryName}`;
};

export default getLocationByAirportCode;
